import { CreditGapsStepCtrl } from './credit-gaps.controller';

export const CreditGapsStepComponent = {
  controller: CreditGapsStepCtrl,
  bindings: {
    nextStep: '&',
    prevStep: '&',
    selectedGradDate: '<',
  },
  template: require('./credit-gaps.html'),
};
